import {ActionTree} from "vuex";
import {ModerationTemplatesState} from "@/store/user_management/template_moderation/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<ModerationTemplatesState, RootState> = {
  getModerationTemplates: ({commit}, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/templates_moderation', params: data})
        .then(resp => {
          commit('setModerationTemplates', resp.data.templates);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  allowTemplate: ({commit, dispatch}, id:number) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `/acapi/templates_moderation/${id}/accept`
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getModerationTemplates');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  denyTemplate: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: `/acapi/templates_moderation/${data.id}/deny`,
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getModerationTemplates');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  onModerateTemplate: ({commit, dispatch}, id:number) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: `/acapi/templates_moderation/${id}/on_moderate`
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getModerationTemplates');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}